import { SET_ELEMENTS_TO_STORE, SET_LOADING_ELEMENTS_TO_STORE } from 'actions/index'

import _map from "lodash/map"
import { ReduxList, Action } from "app/types/app-types"
import { MergadoElementsType } from 'products/types'

export type Elements = ReduxList<MergadoElementsType>
const defaultQueriesState: Elements = {
    data: [],
    error: null,
    isLoaded: false,
    isLoading: false,
    updated: null,
}

export default function (state: Elements = defaultQueriesState, action: Action<any>): Elements {
    switch (action.type) {
        case SET_ELEMENTS_TO_STORE:            
            return {
                ...state,
                data: action.payload,
                isLoaded: true,
                isLoading: false,
                updated: new Date()
            }
        case SET_LOADING_ELEMENTS_TO_STORE:
            return {
                ...state,
                isLoading: action.payload,
                isLoaded: false,
                updated: new Date()
            }
        default:
            return state
    }
}
